import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomerRequestConfirmCreateQuery } from '@/api/skippay/customerRequestConfirmCreateQuery';

import { SuccessMessage } from './SuccessMessage';
import Loader from '@/components/Loader';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';

export const ConfirmSection = ({
	token,
	isRefund,
}: {
	token: string;
	isRefund: boolean;
}): React.JSX.Element => {
	const { t } = useTranslation('personalDataRequests');

	const { isPending, isSuccess } = useCustomerRequestConfirmCreateQuery({ token });

	function renderContent() {
		if (isPending) {
			return <Loader hideLabel />;
		}

		if (isSuccess) {
			return <SuccessMessage isRefund={isRefund} />;
		}

		return (
			<div className="text-center">
				<p className="mb-6 text-sm font-semibold lg:text-base">{t('error.title')}</p>
				<Link
					analyticsParam="newPersonalDataRequest"
					testId="newPersonalDataRequest"
					to={LINKS().personalInformation}
				>
					{t('error.cta')}
				</Link>
			</div>
		);
	}

	return (
		<div className="rounded-xl bg-white px-4 py-6 lg:rounded-4xl lg:p-12">{renderContent()}</div>
	);
};
